import UserLives from './UserLives';

export default UserLives;